import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { useAuthStore } from '~/@api/client/authStore'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { AuthTopNavigation } from '../auth-top-navigation/AuthTopNavigation'
import { ResetPasswordForm } from './reset-password-form/ResetPasswordForm'
import { useResetPassword } from './reset-password-form/useResetPassword'
import { ResetInfo } from './reset-info/ResetInfo'

function ResetPasswordPage() {
  const { token } = useParams<{ token: string }>()
  const { resetPassword, isRequesting, error } = useResetPassword()
  const { setAuthToken } = useAuthStore()
  const { setNotification } = useLocalNotifications()
  const navigate = useNavigate()

  if (!token) return <Navigate to="/" />

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="flex items-start col-span-1">
        <div className="flex flex-col justify-center items-center gap-0 lg:gap-[60px] w-full">
          <AuthTopNavigation />
          <div className="flex flex-col gap-10 lg:gap-6 w-full lg:w-[400px] md:px-5 lg:px-0 lg:py-auto pb-10 lg:pb-20">
            <ResetPasswordForm
              onSubmit={({ password }) => {
                resetPassword(
                  { password, token },
                  {
                    onSuccess: ({ auth }) => {
                      setAuthToken(auth)
                      setNotification('success', 'Heslo bolo úspešne zmenené')
                      navigate('/')
                    },
                  }
                )
              }}
              isRequesting={isRequesting}
              error={error}
            />
          </div>
        </div>
      </div>

      <div className="hidden lg:flex lg:col-span-1 justify-center items-center md:px-20 bg-foreground text-primary-foreground">
        <ResetInfo />
      </div>
    </div>
  )
}

export default ResetPasswordPage
